/**
 * @author        yontaek@zumper.com (Yon Taek Chung)
 * @copyright     Copyright (c) 2023, Zumper
 * @description   searchUI selectors
 */

import type { State } from '@zcode/state-type'

export const selectIsListablesFetching = (state: State) => {
  return !!state.searchUI.isListablesFetching
}
